<template>
  <vue-threejs-birds
    class="birds-container"
    :effectController="effectController"
    :quantity="quantity"
    :canvasBgAlpha="canvasBgAlpha"
    :wingSpan="wingSpan"
    :colorEffect="colorEffect"
    :color1="color1"
    :color2="color2"
    :minHeight="minHeight"
  />
</template>

<script>
  import VueThreejsBirds from 'vue-threejs-birds'
  export default {
    data() {
      return {
        effectController: {
          separation: 20.0,
          alignment: 20.0,
          cohesion: 20.0,
          freedom: 0.75
        },
        quantity: 3,
        canvasBgAlpha: 0,
        color1: 0xff0f,
        color2: 0xe00ff,
        colorEffect: 1,
        wingSpan: 15
      }
    },
    props: {
      minHeight: {
        default: 100,
        type: Number,
        required: false
      }
    },

    components: {
      VueThreejsBirds
    }
  }
</script>

<style scoped>
  .birds-container {
    z-index: -100;
    position: fixed !important ;
    top: 0px;
  }
</style>
